
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
data () {
return {
currentItem: null
}
},
async activated () {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/GoodsInfoHS/Detail', {params: this.$route.query})
this.currentItem = queryPromise.data
this.$vux.loading.hide()
}
}



// WEBPACK FOOTER //
// ./src/components/ImportLinkageTax_HSDetail.vue